export var LocationGroupSumType;
(function (LocationGroupSumType) {
    LocationGroupSumType[LocationGroupSumType["TOTAL"] = 1] = "TOTAL";
    LocationGroupSumType[LocationGroupSumType["AVAILABLE"] = 2] = "AVAILABLE";
})(LocationGroupSumType || (LocationGroupSumType = {}));
//# sourceMappingURL=location-group-sum-type.js.map